
export class tournamenetLabelBox
{   
    private parent:PIXI.Container;
    private label:PIXI.Text;
    private value:PIXI.Text;
    private bg:PIXI.Graphics;
    private icon:PIXI.Sprite;
        constructor(parent:PIXI.Container,textStyle:PIXI.TextStyle,iconVisible:boolean,bigVersion:boolean)
        {
            this.parent=new PIXI.Container();
            parent.addChild(this.parent);

            this.label=new PIXI.Text('-l-',textStyle);
            this.label.anchor.set(0,.5);

        let smallText = new PIXI.TextStyle({
            fontFamily: textStyle.fontFamily,
            fontSize: 33,
            fill: "#ffffff",
            lineHeight: 50,  
            align: "right",
            dropShadow: true,
            dropShadowColor: "#000000",
            dropShadowBlur: 2,
            dropShadowAngle: Math.PI / 6,
            dropShadowDistance: 0,
          });
        // textStyle.align="right"
            this.value=new PIXI.Text('-v-',smallText);
            this.value.anchor.set(1,0.5);
            let fontHeight=parseInt(textStyle.fontSize+'');
            this.bg= new PIXI.Graphics()
            this.bg.beginFill(0x295f7d);
          if(bigVersion)
          {
            // this.bg.drawRoundedRect(0,0,350,50*2,10);
            this.bg.drawRoundedRect(0,0,350,fontHeight*1.5,10);
          }
          else
          {
            this.bg.drawRoundedRect(0,0,350,fontHeight+0,10);
          }

         
            this.bg.endFill();
            this.bg.x=25;
            this.bg.y=-10;
            this.parent.addChild(this.bg);
            this.bg.alpha=.25;
            
            this.parent.addChild(this.label);
            this.parent.addChild(this.value);


            this.icon= new PIXI.Sprite(PIXI.Texture.fromFrame('icon_points.png'));
            this.icon.anchor.set(0,.5);
         
            this.parent.addChild(this.icon);


            //placemnt 
            this.bg.x=400/2-this.bg.width/2;
            
            this.value.y=0//this.bg.height-this.value.height/2-50/2;
            this.icon.y=20//this.value.y;
            this.icon.x=this.bg.width-this.icon.width/2-10;//this.value.x+20;
            this.value.x=this.icon.x-20;

            this.label.scale.set(.5);
            this.value.scale.set(.7)
            this.label.y=-20;
            this.label.x=(400-this.bg.width)/2
            // console.log(this.label.x)
            //---
            this.makeIconVisible(iconVisible);
        }

        public setPosition=(newPos:Array<number>):void=>
        {
          this.parent.position.set(newPos[0],newPos[1]);
        }

        public setValue=(newText:string):void=>
        {
            this.value.text=newText;
            this.value.y=this.bg.height-this.value.height/2-10;
        }
        public setlabel=(newText:string):void=>
        {
            this.label.text=newText;
        }

        private makeIconVisible=(bool:boolean):void=>
        {
            if(bool==false)
            {
                this.icon.alpha=0;
                this.value.x=this.bg.width-10+this.icon.width/2;
            }
        }

        public setLabelBGWidth=(newWidth:number):void=>
        {
            this.bg.width=newWidth;
            let defaultPos=25
            if(newWidth==350)
            {
                this.bg.x=defaultPos;//ladscape mode
        
            }
            else if(newWidth>350)
            {
                let diffrence=newWidth-350;
                this.bg.x=defaultPos-diffrence;
            }
            this.label.x=this.bg.x;
            // this.label.
        }
        // changeScale()

}